export const config = {
  APP_MAIN_URL: "https://sklep.nifc.pl",
  SOCIAL_FACEBOOK_URL: "https://www.facebook.com/people/Narodowy-Instytut-Fryderyka-Chopina/100069819969917",
  SOCIAL_X_URL: "https://x.com/chopininstitute",
  SOCIAL_YOUTUBE_URL: "https://www.youtube.com/channel/UCSTXol20Q01Uj-U5Yp3IqFg",
}